import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";
import Icon from "@ant-design/icons";
import Icons from "assets/icons";
import React from "react";

const {RADIO_BUTTON, TEXT_AREA, INPUT} = FIELD_TYPE;

const css = {xs: 24, sm: 24, md: 12, lg: 12, xl: 12};
const wrapperCol = {xs: 16, md: 16, lg: 16};
const labelCol = {xs: 8, md: 8, lg: 8};

export const FieldsAppearance1: any[] = [
  {
    label: "Teo nhãn cầu:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPEARANCE", "Teo nhãn cầu"],
    value: false,
  },
  {
    label: "Không có nhãn cầu:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPEARANCE", "Không có nhãn cầu"],
    value: false,
  },
  {
    label: "Nhãn cầu nhỏ:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPEARANCE", "Nhãn cầu nhỏ"],
    value: false,
  },
  {
    label: "Mắt giả:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPEARANCE", "Mắt giả"],
    value: false,
  },
  {
    label: "Lồi mắt:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPEARANCE", "Lồi mắt"],
    value: false,
  },
  {
    label: "Bất đối xứng:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPEARANCE", "Bất đối xứng"],
    value: false,
  },
  {
    label: "Chấn thương:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPEARANCE", "Chấn thương"],
    value: false,
  },
  {
    label: "Sưng nề:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPEARANCE", "Sưng nề"],
    value: false,
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["rightJsonValue", "APPEARANCE", "Ghi chú"],
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "APPEARANCE", "show"],
    hide: true,
  },
];

export const FieldsAppearance2: any[] = [
  {
    label: "Teo nhãn cầu:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPEARANCE", "Teo nhãn cầu"],
    value: false,
  },
  {
    label: "Không có nhãn cầu:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPEARANCE", "Không có nhãn cầu"],
    value: false,
  },
  {
    label: "Nhãn cầu nhỏ:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPEARANCE", "Nhãn cầu nhỏ"],
    value: false,
  },
  {
    label: "Mắt giả:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPEARANCE", "Mắt giả"],
    value: false,
  },
  {
    label: "Lồi mắt:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPEARANCE", "Lồi mắt"],
    value: false,
  },
  {
    label: "Bất đối xứng:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPEARANCE", "Bất đối xứng"],
    value: false,
  },
  {
    label: "Chấn thương:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPEARANCE", "Chấn thương"],
    value: false,
  },
  {
    label: "Sưng nề:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPEARANCE", "Sưng nề"],
    value: false,
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "APPEARANCE", "Ghi chú"],
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
    // placeholder: "New still visual branded social...",
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "APPEARANCE", "show"],
    hide: true,
  },
];
